export const Routes = {
  // pages
  Presentation: { path: "/dashboard/overview" },
  DashboardOverview: { path: "/dashboard/overview" },
  Transactions: { path: "/reports" },
  SubAdmin: { path: "/users" },
  Settings: { path: "/settings" },
  BootstrapTables: { path: "/tables/constant-tables" },
  NewReports: { path: "/new-reports" },
  Billing: { path: "/page/billing" },
  Invoice: { path: "/page/invoice" },
  Signin: { path: "/sign-in" },
  ForgotPassword: { path: "/auth/forgot-password" },
  ResetPassword: { path: "/auth/password-reset/:token" },
  ProfileSetup: { path: "/auth/profile-setup/:token" },
  NotFound: { path: "/auth/404" },
  ServerError: { path: "/auth/500" },
  ReportHistory: { path: "./components/ReportHistory.jsx" },
  ReportResult: { path: "/components/ReportHistory" },
  ReportHistoryEdit: { path: "/new-reports/edit" },
  ProjectInput: { path: "/project-input" },
  Customization: { path: "/customization" },
  NDAForm: { path: "/nda-form-Customization" },
  EntityTable: { path: "/entity-info" },
  ProformaUsers: { path: "/proforma-users" },
  ContactOwner: { path: "/contact-owner" },
  Assets: { path: "/assets" },
  AssetsV2: { path: "/assets-v2" },
  ProductionReporting: { path: "/production-reporting" },
  AccessControl: { path: "/access-control" },
  USERJourney: { path: "/user-journey" },
  TrancheBot: { path: "/tranche-bot" },
};
